export const version = "logger/5.0.8";
//# sourceMappingURL=_version.js.map